import React, { useEffect } from "react";

import Navbar from "./Navbar";
import { useSelector } from "react-redux";
import PublicNavbar from "./PublicNavbar.js";

export default function PublicPage({ title, children }) {
  const user = useSelector((state) => state.user);
  useEffect(() => {
    document.title = title;
  }, [title]);
  return (
    <div className="default-layout">
      {user ? <Navbar /> : <PublicNavbar />}

      {children}
    </div>
  );
}
